// Built @Wed, 27 Dec 2023 03:56:16 GMT
import "core-js/modules/es.object.keys.js";
var isSupport = _isLocalStorageUsable();
function probeSupport() {
  try {
    return typeof localStorage !== "undefined" && "setItem" in window.localStorage && !!window.localStorage.setItem;
  } catch (e) {
    return false;
  }
}
function checkIfLocalStorageThrows() {
  var localStorageTestKey = "_localstorage_support_test";
  try {
    window.localStorage.setItem(localStorageTestKey, true);
    window.localStorage.removeItem(localStorageTestKey);
    return false;
  } catch (e) {
    return true;
  }
}
function _isLocalStorageUsable() {
  return probeSupport() && !checkIfLocalStorageThrows();
}
var Strorage = isSupport ? window.localStorage : {};
var LOGKEY = "__xgplayerlogkey";
var LOCAL_LOG = {
  set: function set(value) {
    try {
      var localist = this.get();
      localist.push(value);
      Strorage.setItem(LOGKEY, JSON.stringify(localist));
    } catch (error) {
    }
  },
  get: function get() {
    try {
      var data = Strorage.getItem(LOGKEY);
      if (data) {
        data = JSON.parse(data);
      } else {
        data = [];
      }
      return data;
    } catch (error) {
      return [];
    }
  },
  remove: function remove() {
    try {
      Strorage.removeItem(LOGKEY);
    } catch (error) {
    }
  },
  clear: function clear() {
    try {
      Strorage.clear();
    } catch (error) {
    }
  }
};
export {
  LOCAL_LOG as default
};
